import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Dialog from '../../components/Dialog';
import { ModalPendDocsView } from './ModalPendDocsView';

interface IProps {
  setShow: (value: boolean) => void;
  show: boolean;
  showTutorial?: boolean;
}

const ModalPendDocsController = ({ show, setShow, showTutorial }: IProps) => {
  const [waitTutorial, setWaitTutorial] = useState(true);
  const pendingDocument = useSelector(
    (state: any) => state?.profile?.data?.pendingDocument
  );
  useEffect(() => {
    if (showTutorial === undefined) setWaitTutorial(true);
    if (showTutorial === false) setWaitTutorial(false);
  }, [showTutorial, waitTutorial]);

  useEffect(() => {
    if (waitTutorial === false) {
      setShow(true);
    }
  }, [waitTutorial]);

  if (!pendingDocument?.active) return null;
  return (
    <Dialog
      show={show}
      zIndex={1000}
      maxWidth="360px"
      handlerClose={() => setShow(false)}
    >
      <ModalPendDocsView handlerClose={() => setShow(false)} />
    </Dialog>
  );
};

export default ModalPendDocsController;
